import { useActionParam, useSaveArticleOpti } from "../../../api/actions/action";
import { useAdicionarArtigo } from "../../../api/controllers/artigo";
import { useUpdateGoogleApi } from "../../../api/controllers/googleApi";
import Artigo from "../../../classes/artigo";

export const columns = [
    {
        field: 'title',
        headerName: 'Título do artigo',
        width: 370,
        align: 'left',
        editable: true,
    },
    {
        field: 'keyword',
        headerName: 'Palavra-chave',
        width: 250,
        align: 'left',
        editable: true,
    },
    {
        field: 'postDateFormatted',
        headerName: 'Data de publicação',
        width: 150,
        align: 'left',
        editable: true,
    },
    {
        field: 'categories',
        headerName: 'Categorias',
        sortable: false,
        width: 100,
    },
    {
        field: 'tags',
        headerName: 'Tags',
        sortable: false,
        width: 100,
    },
]

export const conditional = {
    isButtonActived: false
}

export const useSaveAnalytics = () => {
    const { mutate: update } = useUpdateGoogleApi()
    const { mutateAsync: mutateAction } = useActionParam()

    function saveAnalytics(propriedadeEscolhida, contaEscolhida, googleApi) {
        if (googleApi && googleApi.refreshTokenAnalytics && propriedadeEscolhida && propriedadeEscolhida != "") {
            let g = googleApi;
            g.idAnalytics = propriedadeEscolhida.substring(propriedadeEscolhida.length - 9)
            g.refreshTokenAtivo = true
            update(g)

            mutateAction({
                action: 'save_configuration_analytics',
                param: {
                    account: contaEscolhida,
                    property: propriedadeEscolhida
                }
            })
        }
    }

    return { saveAnalytics }
}

export const useSelectPosts = () => {
    function selectPosts(rowsSelected, rows, setSelectedPosts) {
        const arrayPosts = []
        rowsSelected.forEach(async (item) => {
            const filteredPosts = rows?.filter(x => x.id === item)

            for (let i = 0; i < filteredPosts?.length; i++) {
                arrayPosts.push(filteredPosts[i])
            }
        })

        setSelectedPosts(arrayPosts)
    }

    return { selectPosts }
}

export const useAdicionarArtigoBaseOpti = () => {
    const { mutateAsync: savePost, isError } = useAdicionarArtigo()
    const { mutateAsync: saveArticleOpti, isSuccess } = useSaveArticleOpti()
    const countStatus = { error: 0, success: 0 }

    async function savePostBaseOpti(usuarioWp, selectedPosts, setFinallySelection, isGratuito) {
        if (selectedPosts.length <= 5 || isGratuito) {
            for (let i = 0; i < selectedPosts.length; i++) {
                const artigo = new Artigo({
                    idUsuario: usuarioWp.idUsuario, idArtigoWp: selectedPosts[i].id,
                    url: selectedPosts[i]?.url ?? "", html: selectedPosts[i].html,
                    slug: selectedPosts[i].slug, titulo: selectedPosts[i].title,
                    isPublicado: true, idUsuarioWordpress: usuarioWp.id,
                    otimizado: false, dataPublicacao: selectedPosts[i].postDate,
                    listaPalavraChave: selectedPosts[i].keyword === "sem palavra-chave" ? [] : [{ palavra: selectedPosts[i].keyword, prioritaria: true }]
                })

                await savePost(artigo)
                    .then(async res => {
                        countStatus.success++;
                        await saveArticleOpti({
                            action: 'save_article',
                            postId: res.data.idArtigoWp,
                            article: JSON.stringify(res.data)
                        })
                    }).catch(err => { if (err) countStatus.error++ })

                if (countStatus.error > 0) break;
            }
        }

        if (countStatus.success === selectedPosts.length) setFinallySelection(true)
    }

    return { savePostBaseOpti, isSuccess, isError }
}

export const useFilterRows = () => {
    function filterRows(rows, typeSearch, searchValue, rowsSelected) {
        return rows.filter(item => {
            let filteredRows
            if (typeSearch === 'keyword')
                filteredRows = item.keyword.toLowerCase().includes(searchValue.toLowerCase())

            if (typeSearch === 'title')
                filteredRows = item.title.toLowerCase().includes(searchValue.toLowerCase())

            rowsSelected.forEach(element => {
                if (item.id === element)
                    filteredRows = element
            })

            return filteredRows
        })
    }

    return { filterRows }
}